export default __webpack_public_path__ + "static/media/legendary.84302aeb.jpg";